import { makeCygnusApiCall } from "../../../../../api/api";
import { COIRegistryEntry } from "../../COIRegistry.types";

export const saveCOIRegistryEntry = async (
  payload: Partial<COIRegistryEntry> & { SECClientId: string; AffiliateTypeCode: string }
): Promise<boolean> => {
  const response = await makeCygnusApiCall({
    type: "POST",
    url: "/firm_setup/coi_registry",
    payload,
    show_message: true,
    customized_success_message: "COI Registry entry saved successfully.",
    customized_failure_message: "Failed to save COI Registry entry.",
    customized_error_message: "Error occurred while saving the COI Registry entry.",
    isblob: false,
    forMDM: true,
    default_message: true,
  });

  return response.success;
};
